import { ToJSON } from './json';
import { asError } from 'catch-unknown';

export interface ErrorJson {
  stack: string | undefined;
  name: string;
  message: string;
}

export abstract class JSONableError extends Error implements ToJSON {
  public readonly cause: JSONableError | undefined
  constructor(message?: string, cause?: unknown) {
    super(message);
    this.name = this.constructor.name;
    this.cause = cause ? JSONableErrorWrapper.from(cause) : undefined;
  }

  public toJSON(): ErrorJson & { [key: string]: string | number | boolean | Object | undefined } {
    return {
      message: this.message,
      stack: this.stack,
      cause: this.cause?.toJSON(),
      name: this.name,
    };
  }
}

export class JSONableErrorWrapper extends JSONableError {
  public static from(error: Error | unknown): JSONableError {
    return error instanceof JSONableError ? error : new JSONableErrorWrapper(asError(error));
  }

  private constructor(error: Error) {
    super(error.message);
    this.stack = error.stack;
    this.name = error.name;
  }
}
